import IconEdit from "@/images/trend/icon-edit";
import IconLike from "@/images/trend/icon-like";
import IconCollect from "@/images/trend/icon-collect";
import IconComment from "@/images/trend/icon-comment";
import "./Operate.less";
import { TrendItem } from "@/config/types/trend";
import { transNum } from "@/utils/utils";

export default function Operate({ theme, data }: { theme: "light" | "dark"; data: TrendItem }) {
  return (
    <div className={`operate-wrap operate-wrap-${theme}`}>
      <div className="comment-wrap">
        <IconEdit />
        <input type="text" readOnly placeholder="发表评论..." className="comment-input" />
      </div>
      <div className="behavior-wrap">
        <div className="behavior-item">
          <IconLike />
          <div className="behavior-num">{transNum(data?.likeNum || 0)}</div>
        </div>
        <div className="behavior-item">
          <IconCollect />
          <div className="behavior-num">{transNum(data?.collectNum || 0)}</div>
        </div>
        <div className="behavior-item">
          <IconComment />
          <div className="behavior-num">{transNum(data?.commentNum || 0)}</div>
        </div>
      </div>
    </div>
  );
}
